define(
    'viewmodels/shell',[
        './__router', 'plugins/router', 'common/utils', 'jquery', 'lodash',
        'checkPreInit/index', 'atn/atn'
    ],
    function(rootRouter, router, utils, $, _, checkPreInit, atn) {
        'use strict';

        return {
            activate: activate,
            router: router
        };

        function activate() {
            var data = {},
                urlParts = atn.utils.parseURL(window.location.href),
                requestedPath = urlParts.path,
                deferred = $.Deferred(),
                willNavigate;

            checkPreInit.bootStaircase(checkPreInit.onInit(data, function() {
                willNavigate = data.fragment || !requestedPath;
                if (willNavigate) {
                    _.defer(router.navigate, data.fragment || '#app');
                }
                mapMainRoutes()
                    .done(function() {
                        deferred.resolve(!willNavigate);
                    })
                    .fail(function() {
                        deferred.reject('Failed to resolve routes');
                    });
            }));

            return deferred.promise();
        }

        function mapMainRoutes() {
            router.map(rootRouter.routes).buildNavigationModel();
            return router.activate();
        }

    });
